<template>
  <div class="voyage-wrapper">
    <voyage-sidebar
      @applyFilter="applyFilter"
      :isLoading="isLoading"
      :appliedMassId="appliedMassId"
      :isFilterDirty="isFilterDirty"
      @toggleMenu="toggleMenu"
    />
    <voyage-map v-if="ship" SelectedMap="default" :ships="mapShips"
      :Options="{ enableTrail: true, disableSummaryFetch: true, hideVoyageButton: true, trailRange: mapTrailRange }" class="voyage-map" :key="isLoading" />
    <voyage-menu v-if="!isLoading && isMenuOpen" @toggleMenu="toggleMenu" :isMenuOpen="isMenuOpen"/>
  </div>
</template>

<script>
import moment from 'moment';
import Sidebar from '@/views/voyage_report/Sidebar';
import Map from '@/views/map/index';
import Menu from '@/views/voyage_report/Menu';
import { initAssetSummary, applyAssetSummaryFilter } from '@/util/asset-summary-loader';

export default {
  name: 'VoyageReport',
  components: { VoyageSidebar: Sidebar, VoyageMap: Map, VoyageMenu: Menu },
  data() {
    return {
      isLoading: true,
      ship: null,
      isMenuOpen: false,
      appliedDateRange: null,
      appliedMassId: null,
    };
  },
  async mounted() {
    const date = this.$store.getters['filter/date'];
    const initResult = await initAssetSummary(this.$store, {
      dateRange: date,
      allowMinute: false,
      withLastData: true,
    });

    this.ship = initResult.assets.find((asset) => asset.massId === initResult.currentMassId);
    this.appliedDateRange = {
      start: new Date(date.start.valueOf()),
      end: new Date(date.end.valueOf()),
    };
    this.appliedMassId = initResult.currentMassId;
    this.isLoading = false;
  },
  computed: {
    isFilterDirty() {
      if (!this.appliedDateRange) return false;
      const { start, end } = this.$store.getters['filter/date'];
      const currStart = start.valueOf();
      const currEnd = end.valueOf();
      const appliedStart = this.appliedDateRange.start.valueOf();
      const appliedEnd = this.appliedDateRange.end.valueOf();

      return (
        currStart !== appliedStart
        || currEnd !== appliedEnd
        || (this.appliedMassId || null) !== (this.$store.getters['filter/currentMassId'] || null)
      );
    },
    mapTrailRange() {
      const r = this.appliedDateRange;
      if (!r?.start || !r?.end) return undefined;
      return { start: moment(r.start).unix(), end: moment(r.end).unix() };
    },
    // `ship` cuma snapshot; peta butuh versi store biar coordinates hasil
    // fetchShipTrail kebaca.
    mapShips() {
      if (!this.ship) return [];
      const fromStore = this.$store.getters['asset/assets']
        .find((a) => String(a.massId) === String(this.ship.massId));
      return [fromStore || this.ship];
    },
  },
  methods: {
    async applyFilter(options) {
      this.isLoading = true;
      await applyAssetSummaryFilter(this.$store, {
        dateRange: options.dateRange,
        interval: 'hour',
        massId: options.massId,
      });

      this.ship = this.$store.getters['asset/assets'].find((asset) => asset.massId === options.massId);
      this.appliedDateRange = {
        start: new Date(options.dateRange.start.valueOf()),
        end: new Date(options.dateRange.end.valueOf()),
      };
      this.appliedMassId = options.massId;
      this.isLoading = false;
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
  },
};
</script>

<style scoped>
.voyage-wrapper {
  display: flex;
  width: 100%;
  height: calc(100vh - 70px);
}

.voyage-map {
  width: 65% !important;
}
</style>
